import { createFilter } from "../usecases/search-in-object";

let inMemoryRepo = {};

export function saveEmployeeFilter({ forState, searchString }) {
  inMemoryRepo[forState] = { searchString };
}

export function findEmployeeFilter({ forState, keys }) {
  const term =
    (inMemoryRepo[forState] && inMemoryRepo[forState].searchString) || "";
  return createFilter(term, keys, { exactMatch: true });
}

export function clearCache() {
  inMemoryRepo = {};
}
